import React, { useState, useEffect } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import {
    Layout, Breadcrumb, Row, Col, Form, Input, Select, Upload, message, Button, InputNumber, Modal, Spin, Collapse, Space, Tabs
} from 'antd';
import { HomeOutlined, UploadOutlined, SaveOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import JoditEditor from "jodit-react";

import CONSTANT from '../../config/constant';
import { axiosInstance, shopInstance } from '../../config/api';
import * as COMMON from '../../config/common';
import { lang } from 'moment';
const { Panel } = Collapse;
const status = [
    { value: 'publish', label: 'Công khai' },
    { value: 'draft', label: 'Bản nháp' },
];

const currencys = [
    // { value: 'USD', label: 'USD' },
    // { value: 'EUR', label: 'EUR' },
    // { value: 'CHF', label: 'CHF' },
    // { value: 'CAD', label: 'CAD' },
    // { value: 'KRW', label: 'KRW' },
    // { value: 'JPY', label: 'JPY' },
    { value: 'VND', label: 'VND' },
];
const types = [
    { value: 'simple', name: 'Sản phẩm' },
    { value: 'sim', name: 'Sim du lịch' }
]

/** Format giá khi gõ: 100000 => 100,000; hiện đơn vị tiền ở prefix */
const PriceInput = ({ value, onChange, currency, placeholder, style, ...rest }) => {
    const displayValue =
        value === undefined || value === null || value === ''
            ? ''
            : `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    const handleChange = (e) => {
        const digits = e.target.value.replace(/[^\d]/g, '');
        if (digits === '') {
            onChange?.(undefined);
            return;
        }
        onChange?.(Number(digits));
    };

    return (
        <Input
            {...rest}
            prefix={currency || 'VND'}
            value={displayValue}
            onChange={handleChange}
            placeholder={placeholder}
            style={style}
            inputMode="numeric"
        />
    );
};

const ActionProduct = (props) => {
    const { id } = useParams();
    const history = useHistory();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [activeLangTab, setActiveLangTab] = useState('vi');
    /*================= Editor ============== */

    //define variable
    const [categoriesData, setcategoriesData] = useState([]);
    /*================= Images ============== */
    const [imageList, setImageList] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewTitle, setPreviewTitle] = useState('');
    const [previewImage, setPreviewImage] = useState('');
    const [haveVariant, setHaveVariant] = useState(false);
    const onChangeImages = (index) => ({ fileList }) => {
        if (index === -1)
            setImageList(fileList);
        else {
            const values = form.getFieldValue('variants');
            values[index].images = fileList;
            form.setFieldsValue({ variants: values });
        }
    }

    const onPreviewImages = async file => {
        let src = file.url;
        if (!src) {
            src = await new Promise(resolve => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }

        setPreviewImage(src);
        setPreviewVisible(true);
        let _previewTitle = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
        setPreviewTitle(_previewTitle);

    };
    const onRemove = async file => {

        // remove 
    }
    // save image
    const saveImage = async (images) => {
        let arrImage = [];
        if (images.length > 0) {
            for (const item of images) {
                if (item.status === 'done') {
                    if (item.response.code === 200 && item.response.data && item.response.data.filename) {
                        let idImage = await shopInstance.post(`${CONSTANT.API.EXTRA.SAVE_FILE}`, {
                            filename: item.response.data.filename,
                            type: "shop_product"
                        })
                            .then(async res => {
                                if (res && res.data && res.code === 200) {
                                    let filename = res.data.url;
                                    if (typeof filename !== 'undefined') {
                                        return await shopInstance.post(`${CONSTANT.API.PRODUCT.IMAGE}`, {
                                            filename
                                        })
                                            .then(mRes => {
                                                if (mRes && mRes.data && mRes.code === 200) {
                                                    const { data } = mRes;
                                                    if (data) {
                                                        return data._id;
                                                    }
                                                }
                                            }
                                            )
                                    }
                                }
                            });
                        arrImage.push(idImage);
                    }
                }
                else {
                    arrImage.push(item.uid);
                }
            }
        }
        return arrImage;
    };
    const getFieldLabel = (namePath) => {
        const path = Array.isArray(namePath) ? namePath.join('.') : String(namePath || '');
        const labels = {
            name: 'Tên sản phẩm (Tiếng Việt)',
            description: 'Thông số kỹ thuật (Tiếng Việt)',
            'translations.en.name': 'Tên sản phẩm (Tiếng Anh)',
            'translations.en.description': 'Thông số kỹ thuật (Tiếng Anh)',
            categories: 'Danh mục sản phẩm',
            type: 'Loại sản phẩm',
            weight: 'Cân nặng',
            length: 'Chiều dài',
            width: 'Chiều rộng',
            height: 'Chiều cao',
            currency: 'Loại tiền tệ',
            stock_quantity: 'Số lượng',
            price: 'Giá',
        };
        return labels[path] || path;
    };

    const onFinishFailed = ({ errorFields }) => {
        if (!errorFields || errorFields.length === 0) return;

        const hasEnError = errorFields.some((field) => {
            const name = field.name || [];
            return Array.isArray(name) && name[0] === 'translations' && name[1] === 'en';
        });
        if (hasEnError) {
            setActiveLangTab('en');
        } else {
            const hasViError = errorFields.some((field) => {
                const name = field.name || [];
                return !Array.isArray(name) || name[0] !== 'translations';
            });
            if (hasViError) setActiveLangTab('vi');
        }

        const fieldNames = errorFields
            .slice(0, 3)
            .map((field) => getFieldLabel(field.name))
            .join(', ');
        const moreCount = errorFields.length > 3 ? ` và ${errorFields.length - 3} trường khác` : '';
        message.warning(`Vui lòng nhập đầy đủ thông tin bắt buộc: ${fieldNames}${moreCount}`, 5);
    };

    // submit
    const onFinish = async (values) => {
        setSubmitting(true);
        try {
            // Ensure translations object structure
            if (!values.translations) {
                values.translations = { en: {} };
            } else if (!values.translations.en) {
                values.translations.en = {};
            }
            const user = localStorage.getItem(CONSTANT.STORAGE_KEY_USER);

        let productSave = {
            name: values.name,
            delivery_time_approx: values.delivery_time_approx,
            content: values.content,
            note: values.note,
            description: values.description,
            categories: values.categories,
            price: values.price,
            currency: values.currency,
            status: values.status,
            images: await saveImage(imageList),
            stock_quantity: values.stock_quantity,
            type: values.type,
            translations: values.translations,
            weight: values.weight, // (gram) (không vượt 50000)
            length: values.length, // (cm) (không vượt quá 200cm)
            width: values.width, // (cm) (không vượt quá 200cm)
            height: values.height, // (cm) (không vượt quá 200cm)
        }
        
        const rawUser = JSON.parse(user);
        if(rawUser?._id){
            productSave.created_by = rawUser?._id;
        }

        if(!id){
            productSave.translations.lang = "en";
            productSave.translations.name = productSave.translations.en.name;
            productSave.translations.description = productSave.translations.en.description;
            productSave.translations.delivery_time_approx = productSave.translations.en.delivery_time_approx;
            productSave.translations.content = productSave.translations.en.content;
            productSave.translations.note = productSave.translations.en.note;
            delete productSave.translations.en;
        }

        let productId = await saveProduct(productSave);
        let statusFinish = true
        if (productId && values.variants) {
            statusFinish = await saveVariants(values.variants, values.attributes, productId);
        }
            if (id) {
                if (productId && statusFinish) {
                    message.success('Sửa sản phẩm thành công!')
                    history.push('/product');
                }
                else {
                    message.error('Sửa sản phẩm không thành công!')
                }
            }
            else {
                if (productId && statusFinish) {
                    message.success('Thêm mới sản phẩm thành công!')
                    history.push('/product');
                }
                else {
                    message.error('Thêm mới sản phẩm không thành công!')
                }
            }
        } catch (error) {
            message.error('Có lỗi xảy ra khi xử lý dữ liệu!');
            console.error('Error:', error);
        } finally {
            setSubmitting(false);
        }
    };
    const saveVariants = async (variants, attributes, productId) => {
        let save = false;
        if (!id) {
            for (let variant of variants) {
                variant.product = productId;
                variant.images = await saveImage(variant.images);
                for (let [index, attribute] of attributes.entries()) {
                    if (attributes.length === variant.name.split('/').length) {
                        let optAdd = [{
                            name: variant.name.split('/')[index],
                            value: variant.name.split('/')[index],
                        }]
                        const attributeAdd = {
                            name: attribute.name,
                            code: attribute.name,
                            options: optAdd
                        }
                        await shopInstance.post(`${CONSTANT.API.PRODUCT.ATTRIBUTE}`, attributeAdd)
                            .then(res => {
                                if (res && res.data && res.code === 200) {
                                    variant.attributes.push(res.data._id);
                                }
                            }).catch(error => { return false; });
                    }
                }
                await shopInstance.post(`${CONSTANT.API.PRODUCT.PRODUCT}/${productId}/variants`, variant)
                    .then(res => {
                        if (res && res.data && res.code === 200) {
                            save = true
                        }
                    }).catch(error => { return false; });
            }
        }
        else {
            for (let variant of variants) {
                variant.product = productId;
                variant.images = await saveImage(variant.images);
                await shopInstance.patch(`${CONSTANT.API.PRODUCT.VARIANT}/${variant._id}`, variant)
                    .then(res => {
                        if (res && res.data && res.code === 200) {
                            save = true
                        }
                    }).catch(error => { return false; });
            }
        }
        return save;
    }
    const saveProduct = async (product) => {
        if (!id) {
            return await shopInstance.post(`${CONSTANT.API.PRODUCT.PRODUCT}`, product)
                .then(res => {
                    if (res && res.data && res.code === 200) {
                        return res.data._id;
                    }
                    else {
                        message.error('Thêm mới thất bại! Vui lòng thử lại sau.');
                    }
                });
        }
        else {
            return await shopInstance.patch(`${CONSTANT.API.PRODUCT.PRODUCT}/${id}`, product)
                .then(res => {
                    if (res && res.data && res.code === 200) {
                        return res.data._id;
                    }
                    else {
                        message.error('Sửa thông tin thất bại! Vui lòng thử lại sau.');
                    }
                });
        }
    }
    useEffect(() => {
        loadCategory();
        if (id && id !== '') {
            loadProduct();
        }
    }, []);
    const loadCategory = async () => {
        await shopInstance.get(`${CONSTANT.API.PRODUCT.CATEGORY}?perPage=-1&is_active=true`)
            .then(async res => {
                if (res && res.data && res.code === 200) {
                    let cates = await sortCategory(res.data);
                    setcategoriesData(cates);
                }
            });
    }
    const sortCategory = (data) => {
        let arr = [];
        data.forEach(level_1 => {
            arr.push(level_1);
            // level_1
            if (level_1.childs.length > 0) {
                level_1.childs.forEach(level_2 => {
                    arr.push(level_2);
                    // level_2
                    if (level_2.childs.length > 0) {
                        level_2.childs.forEach(level_3 => {
                            arr.push(level_3);
                            // level_3
                            if (level_3.childs.length > 0) {
                                level_3.childs.forEach(level_4 => {
                                    arr.push(level_4);
                                })
                            }
                        })
                    }
                });
            }
        })
        arr.map((aData) => {
            if (aData.level === 2) {
                aData.tmpName = '   └ ' + aData.name;
            }
            else if (aData.level === 3) {
                aData.tmpName = '        └ ' + aData.name;
            }
            else if (aData.level === 4) {
                aData.tmpName = '             └ ' + aData.name;
            }
            else {
                aData.tmpName = '♦ ' + aData.name;
            }
        })

        return arr;
    }
    const loadProduct = async () => {
        setLoading(true);
        await shopInstance.get(`${CONSTANT.API.PRODUCT.PRODUCT}/${id}`)
            .then(async res => {
                if (res && res.data && res.code === 200) {
                    const { data } = res;
                    form.setFieldsValue({
                        name: data.name,
                        delivery_time_approx: data.delivery_time_approx,
                        content: data.content,
                        description: data.description,
                        note: data.note,
                        categories: data.categories && data.categories.length > 0 ? data.categories.map(i => i._id) : [],
                        price: data.price,
                        currency: data.currency,
                        status: data.status,
                        images: [],
                        stock_quantity: data.stock_quantity,
                        type: data.type,
                        commission_value: data.commission_value,
                        created_by: data.created_by,
                        translations: data.translations || { en: {} },

                        weight: data.weight,
                        length: data.length,
                        width: data.width,
                        height: data.height,
                    });
                    if (data.images && data.images.length > 0) {
                        let images = [];
                        for (let i = 0; i < res?.data?.images?.length; i++) {
                            let image = res?.data?.images[i];
                            if (image) {
                                images = images.concat({
                                    uid: image._id,
                                    name: CONSTANT.STATIC_URL + image.filename,
                                    status: 'done-add',
                                    url: CONSTANT.STATIC_URL + image.filename,
                                    thumbUrl: CONSTANT.STATIC_URL + image.filename
                                });
                            }
                        }
                        setImageList(images);
                    }
                    await shopInstance.get(`${CONSTANT.API.PRODUCT.VARIANT}?product=${id}&perPage=-1`)
                        .then(async res => {
                            if (res && res.data && res.code === 200) {
                                for (let variant of res.data.docs) {
                                    let imagesLoad = [];
                                    for (let image of variant.images) {
                                        imagesLoad = imagesLoad.concat({
                                            uid: image._id,
                                            name: CONSTANT.STATIC_URL + image.filename,
                                            status: 'done-add',
                                            url: CONSTANT.STATIC_URL + image.filename,
                                            thumbUrl: CONSTANT.STATIC_URL + image.filename
                                        });
                                    }
                                    variant.name = variant.attributes.length > 0 ? variant.attributes.map((item) => item.options[0].name).join('/') : '';
                                    variant.images = imagesLoad;
                                }
                                form.setFieldsValue({
                                    variants: res.data?.docs
                                });
                                if (res.data.docs.length > 0) {
                                    setHaveVariant(true);
                                }
                            }
                        });
                }
            })
            .catch(error => message.warning('Sản phẩm không tồn tại!' + error.message, 2.5).then(() => history.push('/product')))
        setLoading(false);
    }

    const autoGeneralProductVariation = async () => {
        form.setFieldsValue({ variants: [] });
        if (form.getFieldValue('attributes') && form.getFieldValue('attributes').length > 0) {
            addProductVariation([], 0,);
        }
        else {
            setHaveVariant(false);
            message.warning('Vui lòng thêm nhóm phân loại sản phẩm', 2.5);
        }
    }
    const addProductVariation = (arr, optionIndex) => {
        if (form.getFieldValue('attributes')) {
            let maxIndexOption = form.getFieldValue('attributes').length - 1;
            let j, l, optionCombinations, optionValue;
            if (form.getFieldValue('attributes')[optionIndex] && form.getFieldValue('attributes')[optionIndex].name !== '') {
                if (form.getFieldValue('attributes')[optionIndex].opts && form.getFieldValue('attributes')[optionIndex].opts !== '') {
                    for (j = 0, l = form.getFieldValue('attributes')[optionIndex].opts.split(',').length; j < l; j = j + 1) {
                        optionCombinations = arr.slice(0);
                        optionValue = {
                            name: form.getFieldValue('attributes')[optionIndex].opts.split(',')[j]
                        };
                        optionCombinations.push(optionValue);
                        if (optionIndex === maxIndexOption) {
                            let productName = optionCombinations.map((item) => item.name).join('/');
                            let variation = {
                                product: "",
                                name: productName,
                                stock_quantity: 0,
                                price: 0,
                                images: [],
                                attributes: []
                            };
                            let tmpVariant = form.getFieldValue('variants');
                            tmpVariant.push(variation);
                            form.setFieldsValue({
                                variants: tmpVariant
                            });
                            setHaveVariant(true);
                        } else {
                            addProductVariation(optionCombinations, optionIndex + 1, maxIndexOption);
                        }
                    }
                }
                else {
                    message.warning('Vui lòng nhập thuộc tính phân loại (Các thuộc tính cách nhau bởi dấu phẩy. VD: vàng,xanh,đỏ ...)', 5);
                }
            }
            else {
                message.warning('Vui lòng nhập tên phân loại (vd: kích thước, màu sắc ...)', 5);
            }
        }
    }
    return (
        <div>
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item >
                    <Link to="/"><HomeOutlined /></Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/product">Sản phẩm</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    {id && id !== '' ? 'Sửa thông tin' : 'Thêm mới'}
                </Breadcrumb.Item>
            </Breadcrumb>
            <Layout.Content className="layout-content">
                {
                    loading &&
                    <div style={{ textAlign: 'center' }}>
                        <Spin />
                    </div>
                }

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    initialValues={{
                        currency: "VND",
                        type: "simple",
                        status: "draft"
                    }}>
                    <Row gutter={16}>
                        <Col xs={24} sm={24} md={18}>

                            <Tabs activeKey={activeLangTab} onChange={setActiveLangTab} type="card" size="large">
                                <Tabs.TabPane tab={'Tiếng Việt'} key="vi" forceRender={true} >
                                    <Form.Item
                                        label="Tên sản phẩm"
                                        name="name"
                                        required tooltip="Trường bắt buộc nhập"
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập tên sản phẩm (Tiếng Việt)!' },
                                        ]}
                                    >
                                        <Input placeholder="Tên sản phẩm" />
                                    </Form.Item>
                                    <Collapse defaultActiveKey={['1']} bordered={false}>
                                        <Panel header="Thông số kỹ thuật" key="1">
                                            <Form.Item
                                                name="description"
                                                rules={[
                                                    { required: true, message: 'Vui lòng nhập thông số kỹ thuật (Tiếng Việt)!' },
                                                ]}>
                                                <JoditEditor
                                                    config={{ height: 500 }}
                                                />
                                            </Form.Item>
                                        </Panel>
                                        <Panel header="Mô tả sản phẩm" key="2">
                                            <Form.Item name="content"
                                            >
                                                <JoditEditor
                                                    config={{ height: 500 }}
                                                />
                                            </Form.Item>
                                        </Panel>
                                        <Panel header="Lưu ý" key="3">
                                            <Form.Item name="note">
                                                <JoditEditor
                                                    config={{ height: 300 }}
                                                />
                                            </Form.Item>
                                        </Panel>
                                        <Panel header="Phân loại sản phẩm" key="4">
                                            <Form.List name="attributes">
                                                {(fields, { add, remove }) => (
                                                    <>
                                                        {fields.map(({ key, name, opts, fieldKey, ...restField }) => (
                                                            <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                                                <Form.Item
                                                                    {...restField}
                                                                    name={[name, 'name']}
                                                                    fieldKey={[fieldKey, 'name']}
                                                                    rules={[{ required: true, message: 'Vui lòng nhập tên nhóm' }]}
                                                                >
                                                                    <Input placeholder="Tên nhóm phân loại" />
                                                                </Form.Item>
                                                                <Form.Item
                                                                    {...restField}
                                                                    name={[name, ['opts']]}
                                                                    fieldKey={[fieldKey, ['opts']]}
                                                                    rules={[{ required: true, message: 'Vui lòng nhập thuộc tính' }]}
                                                                >
                                                                    <Input placeholder="Thuộc tính phân loại cách nhau bởi dấu phẩy" style={{ width: '450px' }} />
                                                                </Form.Item>
                                                                <MinusCircleOutlined onClick={() => {
                                                                    remove(name);
                                                                    autoGeneralProductVariation();
                                                                }} />
                                                            </Space>
                                                        ))}
                                                        {
                                                            !id && <Form.Item>
                                                                <Button type="dashed" style={{ width: '200px' }} onClick={() => add()} block icon={<PlusOutlined />}>
                                                                    Thêm nhóm phân loại
                                                                </Button>
                                                                <Button type="dashed" style={{ width: '200px', float: 'right' }} onClick={() => autoGeneralProductVariation()} block icon={<PlusOutlined />}>
                                                                    Tạo sản phẩm</Button>
                                                            </Form.Item>
                                                        }

                                                    </>
                                                )}
                                            </Form.List>
                                            <div className="ant-table-content">
                                                <table style={{ tableLayout: "auto" }}>
                                                    <thead className="ant-table-thead">
                                                        <tr>
                                                            <th className="ant-table-cell">Phân loại</th>
                                                            <th className="ant-table-cell">Số lượng</th>
                                                            <th className="ant-table-cell">Giá bán</th>
                                                            <th className="ant-table-cell">Hình ảnh</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="ant-table-tbody">
                                                        <Form.List name="variants">
                                                            {(fields, { }) => (
                                                                <>
                                                                    {fields.map(({ key, name, fieldKey, ...restField }) => (
                                                                        <tr className="ant-table-row" key={name}>
                                                                            <td className="ant-table-cell" style={{ width: '250px' }}>
                                                                                {form.getFieldValue('variants')[name].name}
                                                                            </td>
                                                                            <td className="ant-table-cell" style={{ width: '100px' }}>
                                                                                <Form.Item
                                                                                    {...restField}
                                                                                    name={[name, 'stock_quantity']}
                                                                                    fieldKey={[name, 'stock_quantity']}
                                                                                    rules={[{ required: true, message: 'Vui lòng nhập số lượng' }]}
                                                                                >
                                                                                    <Input placeholder="Nhập số lượng" />
                                                                                </Form.Item>
                                                                            </td>
                                                                            <td className="ant-table-cell" style={{ width: '200px' }}>
                                                                                <Form.Item
                                                                                    noStyle
                                                                                    shouldUpdate={(prev, cur) => prev.currency !== cur.currency}
                                                                                >
                                                                                    {() => (
                                                                                        <Form.Item
                                                                                            {...restField}
                                                                                            name={[name, 'price']}
                                                                                            fieldKey={[name, 'price']}
                                                                                            rules={[{ required: true, message: 'Vui lòng nhập giá bán' }]}
                                                                                        >
                                                                                            <PriceInput
                                                                                                currency={form.getFieldValue('currency')}
                                                                                                placeholder="Nhập giá bán"
                                                                                                style={{ width: '100%' }}
                                                                                            />
                                                                                        </Form.Item>
                                                                                    )}
                                                                                </Form.Item>
                                                                            </td>
                                                                            <td className="ant-table-cell">
                                                                                {/* Begin Images */}
                                                                                <Form.Item>
                                                                                    <ImgCrop
                                                                                        rotate
                                                                                        modalTitle="Sửa ảnh"
                                                                                        modalOk="Đồng ý"
                                                                                        aspect={800 / 672}
                                                                                        quality={0.8}
                                                                                        modalWidth={800}
                                                                                    >
                                                                                        <Upload
                                                                                            listType="picture-card"
                                                                                            action={`${CONSTANT.API.EXTRA.UPLOAD_IMAGE}`}
                                                                                            fileList={form.getFieldValue('variants')[name].images}
                                                                                            onPreview={onPreviewImages}
                                                                                            onChange={onChangeImages(name)}
                                                                                            withCredentials={true}
                                                                                            headers={{
                                                                                                'X-TK': CONSTANT.API.KEY
                                                                                            }}
                                                                                            onRemove={onRemove}
                                                                                        >
                                                                                            {
                                                                                                form.getFieldValue('variants')[name].images.length < 5 &&
                                                                                                <div>
                                                                                                    <PlusOutlined />
                                                                                                    <div style={{ marginTop: 8 }}>Chọn hình</div>
                                                                                                </div>
                                                                                            }
                                                                                        </Upload>
                                                                                    </ImgCrop>
                                                                                    <Modal
                                                                                        visible={previewVisible}
                                                                                        title={previewTitle}
                                                                                        footer={null}
                                                                                        onCancel={() => setPreviewVisible(false)}>
                                                                                        <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                                                                    </Modal>
                                                                                </Form.Item>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </>
                                                            )}
                                                        </Form.List>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </Panel>
                                    </Collapse>

                                </Tabs.TabPane>
                                <Tabs.TabPane tab={'Tiếng Anh'} key="en" forceRender={true} >
                                    <Form.Item
                                        label="Tên sản phẩm"
                                        name={['translations', 'en', 'name']}
                                        required tooltip="Trường bắt buộc nhập"
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập tên sản phẩm (Tiếng Anh)!' },
                                        ]}
                                    >
                                        <Input placeholder="Tên sản phẩm (English)" />
                                    </Form.Item>
                                    <Collapse defaultActiveKey={['1']} bordered={false}>
                                        <Panel header="Thông số kỹ thuật" key="1">
                                            <Form.Item
                                                name={['translations', 'en', 'description']}
                                                rules={[
                                                    { required: true, message: 'Vui lòng nhập thông số kỹ thuật (Tiếng Anh)!' },
                                                ]}>
                                                <JoditEditor
                                                    config={{ height: 500 }}
                                                />
                                            </Form.Item>
                                        </Panel>
                                        <Panel header="Mô tả sản phẩm" key="2">
                                            <Form.Item name={['translations', 'en', 'content']}
                                            >
                                                <JoditEditor
                                                    config={{ height: 500 }}
                                                />
                                            </Form.Item>
                                        </Panel>
                                        <Panel header="Note" key="3">
                                            <Form.Item name={['translations', 'en', 'note']}>
                                                <JoditEditor
                                                    config={{ height: 300 }}
                                                />
                                            </Form.Item>
                                        </Panel>
                                    </Collapse>

                                </Tabs.TabPane>
                            </Tabs>

                        </Col>
                        <Col xs={24} sm={24} md={6}>
                            {/* Begin Images */}
                            <Form.Item label="Hình ảnh">
                                <ImgCrop
                                    rotate
                                    modalTitle="Sửa ảnh"
                                    modalOk="Đồng ý"
                                    aspect={800 / 672}
                                    quality={0.8}
                                    modalWidth={800}
                                >
                                    <Upload
                                        listType="picture"
                                        action={`${CONSTANT.API.EXTRA.UPLOAD_IMAGE}`}
                                        fileList={imageList}
                                        onPreview={onPreviewImages}
                                        onChange={onChangeImages(-1)}
                                        withCredentials={true}
                                        headers={{
                                            'X-TK': CONSTANT.API.KEY
                                        }}
                                        onRemove={onRemove}
                                    >
                                        {
                                            imageList.length < 10 &&
                                            <Button icon={<UploadOutlined />}>Chọn ảnh tải lên</Button>
                                        }
                                    </Upload>
                                </ImgCrop>
                                <Modal
                                    visible={previewVisible}
                                    title={previewTitle}
                                    footer={null}
                                    onCancel={() => setPreviewVisible(false)}>
                                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                </Modal>
                            </Form.Item>
                            {/* End Images */}
                            <Form.Item
                                label="Danh mục"
                                name="categories"
                                placeholder="Chọn danh mục của sản phẩm"
                                required tooltip="Trường này bắt buộc chọn"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn danh mục của sản phẩm !' }
                                ]}
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    placeholder="Vui lòng chọn danh mục"
                                    style={{ width: '100%' }}
                                >
                                    {
                                        categoriesData.length > 0 &&
                                        categoriesData.map(item => <Select.Option key={item._id}>{item.tmpName}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Loại sản phẩm"
                                name="type"
                                required tooltip="Trường bắt buộc nhập"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn loại sản phẩm!' }
                                ]}
                            >
                                <Select
                                    placeholder="Chọn loại sản phẩm"
                                    optionFilterProp="children"
                                    style={{ width: '100%' }}>
                                    {
                                        types.length > 0 &&
                                        types.map(item => <Select.Option key={item.value}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Cân nặng"
                                name="weight"
                                required tooltip="Trường bắt buộc nhập"
                                rules={[
                                    { required: true, message: 'Vui lòng điền cân nặng sản phẩm!' },
                                    { type: 'number', max: 50000, message: 'Cân nặng không được vượt quá 50,000 gram!' }
                                ]}
                            >
                                <InputNumber
                                    placeholder="Nhập cân nặng <= 50,000 gram"
                                    style={{ width: '100%' }}
                                    min={0}
                                    max={50000}
                                    prefix="Gram"
                                />
                            </Form.Item>
                            <Form.Item
                                label="Chiều dài"
                                name="length"
                                required tooltip="Trường bắt buộc nhập"
                                rules={[
                                    { required: true, message: 'Vui lòng điền chiều dài sản phẩm!' },
                                    { type: 'number', max: 199, message: 'Chiều dài không được vượt quá 200 cm!' }
                                ]}
                            >
                                <InputNumber
                                    placeholder="Nhập chiều dài <= 200 cm"
                                    style={{ width: '100%' }}
                                    min={0}
                                    max={200}
                                    prefix="Cm"
                                />
                            </Form.Item>
                            <Form.Item
                                label="Chiều rộng"
                                name="width"
                                required tooltip="Trường bắt buộc nhập"
                                rules={[
                                    { required: true, message: 'Vui lòng điền chiều rộng sản phẩm!' },
                                    { type: 'number', max: 199, message: 'Chiều rộng không được vượt quá 200 cm!' }
                                ]}
                            >
                                <InputNumber
                                    placeholder="Nhập chiều rộng <= 200 cm"
                                    style={{ width: '100%' }}
                                    min={0}
                                    max={200}
                                    prefix="Cm"
                                />
                            </Form.Item>
                            <Form.Item
                                label="Chiều cao"
                                name="height"
                                required tooltip="Trường bắt buộc nhập"
                                rules={[
                                    { required: true, message: 'Vui lòng điền chiều cao sản phẩm!' },
                                    { type: 'number', max: 199, message: 'Chiều cao không được vượt quá 200 cm!' }
                                ]}
                            >
                                <InputNumber
                                    placeholder="Nhập chiều cao <= 200 cm"
                                    style={{ width: '100%' }}
                                    min={0}
                                    max={200}
                                    prefix="Cm"
                                />
                            </Form.Item>

                            <Form.Item
                                label="Loại tiền tệ"
                                name="currency"
                                required tooltip="Trường bắt buộc nhập"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn loại tiền tệ!' }
                                ]}
                            >
                                <Select
                                    placeholder="Loại tiền tệ"
                                    optionFilterProp="children"
                                    style={{ width: '100%' }}>
                                    {
                                        currencys.length > 0 &&
                                        currencys.map(item => <Select.Option key={item.value}>{item.label}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            {
                                haveVariant === false &&
                                <Form.Item
                                    label="Số lượng"
                                    name="stock_quantity"
                                    required tooltip="Trường bắt buộc nhập"
                                    rules={[
                                        { required: true, message: 'Vui lòng số lượng' },
                                    ]}
                                >
                                    <InputNumber
                                        placeholder="Nhập số lượng"
                                        style={{ width: '100%' }}
                                        min={0} />
                                </Form.Item>
                            }
                            <Form.Item
                                noStyle
                                shouldUpdate={(prev, cur) => prev.currency !== cur.currency}
                            >
                                {() => (
                                    <Form.Item
                                        label="Giá"
                                        name="price"
                                        required tooltip="Trường bắt buộc nhập"
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập giá' },
                                        ]}
                                    >
                                        <PriceInput
                                            currency={form.getFieldValue('currency')}
                                            placeholder="Nhập giá"
                                            style={{ width: '100%' }}
                                        />
                                    </Form.Item>
                                )}
                            </Form.Item>
                            <Form.Item label="Trạng thái" name="status">
                                <Select
                                    placeholder="Chọn trạng thái"
                                    style={{ width: '100%' }}>
                                    {
                                        status.map(item => <Select.Option key={item.value}>{item.label}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <div className="footer-toolbar">
                        <div className="right">
                            <Button 
                                type="primary" 
                                icon={<SaveOutlined />}
                                htmlType="submit"
                                loading={submitting}
                                disabled={submitting}
                            >
                                {submitting ? 'Đang xử lý...' : 'Lưu thông tin'}
                            </Button>
                        </div>

                    </div>
                </Form>

            </Layout.Content>

        </div >
    )

}

export default ActionProduct;
